import { BUSINESS_PAYMENT_TYPES } from "@/constants/businessExpenses";
import { z } from "zod";

export const createBusinessExpenseSchema = z.object({
  organization_id: z.string().optional(),
  property_id: z.string().optional(),
  expense_type_id: z.string().min(1, "Debe seleccionar un tipo de egreso"),
  expense_subtype_id: z
    .string()
    .min(1, "Debe seleccionar un subtipo de egreso"),
  expense_description: z.string().optional(),
  payment_type: z.enum(["Efectivo", "Transferencia", "Tarjeta de Crédito", "Tarjeta de Débito", "Deducción"]),
  total_payment: z.number().min(0.01, "El pago total debe ser mayor a 0").optional().nullable(),
  payment_date: z.date().optional().nullable(),
  receipt_url: z.string().optional(),
}).refine((data) => data.total_payment != null && data.total_payment >= 0.01, {
  message: "El pago total debe ser mayor a 0",
  path: ["total_payment"],
});

export type CreateBusinessExpenseData = z.infer<
  typeof createBusinessExpenseSchema
>;
